import * as React from 'react';

import { IRegularInfrastructureData } from '../../../types/map';
import { getNextAvailableYear } from '../helpers';

export const useSelectedYear = (
  infrastructureMapByYearRef: React.MutableRefObject<Map<number, IRegularInfrastructureData>>,
) => {
  const [nextAvailableYear, setNextAvailableYear] = React.useState<number | null>(null);
  const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear());

  const handleSelectYear = React.useCallback(
    (selectedYear: number) => {
      const nextYear = getNextAvailableYear(selectedYear, infrastructureMapByYearRef.current);

      setSelectedYear(selectedYear);
      setNextAvailableYear(nextYear);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [infrastructureMapByYearRef, infrastructureMapByYearRef.current],
  );

  return { handleSelectYear, selectedYear, nextAvailableYear };
};
